import { StyledAsteriskSymbol } from './styles';

const AsteriskSymbol = () => <StyledAsteriskSymbol />;

export default AsteriskSymbol;
